import SortUtil from "./sort";
import moment from "moment-timezone/builds/moment-timezone-with-data";
import { cloneDeep, round } from "lodash";
const format = {
    date: (d) => {
        let year = d.getFullYear();
        let month = d.getMonth() + 1;
        let day = d.getDate();
        if (month < 10) month = "0" + month;
        if (day < 10) day = "0" + day;
        return year + "-" + month + "-" + day;
    },
    getGridDateFormat: (d) => {
        let date = format.getDDMMYYYYDate(d);
        let time =
            ("00" + d.getHours()).slice(-2) +
            ":" +
            ("00" + d.getMinutes()).slice(-2) +
            ":" +
            ("00" + d.getSeconds()).slice(-2) +
            "." +
            ("000" + d.getMilliseconds()).slice(-3);
        return date + " " + time;
    },
    getDDMMYYYYDate: (d) => {
        var year = d.getFullYear();
        var month = d.getMonth() + 1;
        var day = d.getDate();
        if (month < 10) month = "0" + month;
        if (day < 10) day = "0" + day;
        return day + "." + month + "." + year;
    },
};

export const msToHours = (s)=>{
    let ms = s % 1000;
    s = (s - ms) / 1000;
    let secs = s % 60;
    s = (s - secs) / 60;
    let mins = s % 60;
    let hrs = (s - mins) / 60;
    //
    let minsInHrs = mins/60;
    let secondsInHrs = secs/3600
    //
    let totalHours = hrs+minsInHrs+secondsInHrs
    if (totalHours<1){
        return round(totalHours,2)
    }
    if (totalHours<10){
        return round(totalHours,1)
    }
    return round(totalHours)
}

export const machineTimesToHours = (machineTimesArray) =>{
    let arr = [];
    machineTimesArray.forEach((obj)=>{
        let newObj = {...obj}
        newObj.failureDuration = msToHours(obj.failureDuration)
        newObj.idleAfterRunningDuration = msToHours(obj.idleAfterRunningDuration)
        newObj.idleAfterFailureDuration = msToHours(obj.idleAfterFailureDuration)
        newObj.shiftDuration = msToHours(obj.shiftDuration)
        newObj.failureTimeoutDuration = msToHours(obj.failureTimeoutDuration)
        newObj.runningDuration = msToHours(obj.runningDuration)
        newObj.failureDurationPerDay = msToHours(obj.failureDurationPerDay)
        newObj.idleAfterRunningDurationPerDay = msToHours(obj.idleAfterRunningDurationPerDay)
        newObj.idleAfterFailureDurationPerDay = msToHours(obj.idleAfterFailureDurationPerDay)
        newObj.shiftDurationPerDay = msToHours(obj.shiftDurationPerDay)
        newObj.failureTimeoutDurationPerDay = msToHours(obj.failureTimeoutDurationPerDay)
        newObj.runningDurationPerDay = msToHours(obj.runningDurationPerDay)
        arr.push(newObj);
    })
    return arr;
}

export const machineHealthDataToHours = (machineHealthData) =>{
    let arr = [];
    machineHealthData.forEach((element)=>{
        let dailyArr = [];
        let deviceArr = [];

        if(element.dailyData.length > 0){
            element.dailyData.forEach((obj)=>{
                let newObj = {...obj}
                newObj.runningDuration = msToHours(obj.runningDuration)
                dailyArr.push(newObj)
            })
        }
    
        if(element.deviceData.length > 0){
            element.deviceData.forEach((obj)=>{
                let newObj = {...obj}
                newObj.runningDuration = msToHours(obj.runningDuration)
                deviceArr.push(newObj)
            })
        }
    
        let newObj = {...element}
        newObj.runningDuration = msToHours(element.runningDuration)
        newObj.dailyData = dailyArr;
        newObj.deviceData = deviceArr;

        

        arr.push(newObj)
    })
    return arr;
}

export const runningDurationToHours = (objArray) =>{
    let arr = [];
    objArray.forEach((obj)=>{
        let newObj = cloneDeep(obj)
        newObj.runningDuration = msToHours(obj.runningDuration)
        arr.push(newObj)
    })
    return arr;
}

export default format;
